"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaDocumentPdf = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPdf = require("react-pdf");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _utilitaires = require("../../utils/utilitaires");

require("../../css/mfa-documentpdf.css");

var _MfaDocumentPdfVisionneur = require("./MfaDocumentPdfVisionneur");

var _utilitaires2 = require("../../utils/utilitaires.elements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(_reactPdf.pdfjs.version, "/pdf.worker.js");

var MfaDocumentPdf = /*#__PURE__*/function (_Component) {
  _inherits(MfaDocumentPdf, _Component);

  var _super = _createSuper(MfaDocumentPdf);

  function MfaDocumentPdf(props) {
    var _this;

    _classCallCheck(this, MfaDocumentPdf);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "sourceEtatPrecedente", void 0);

    _defineProperty(_assertThisInitialized(_this), "sourceDonneePrecedente", void 0);

    _defineProperty(_assertThisInitialized(_this), "observeur", void 0);

    _defineProperty(_assertThisInitialized(_this), "referenceVisionneur", void 0);

    var source = (0, _utilitaires.estDefini)(_this.props.source) ? _this.props.source : null;
    _this.state = {
      source: source,
      sourceOriginale: source,
      nombrePages: 0,
      noPage: _this.obtenirNombreInitial('noPage', 1),
      charge: false,
      zoom: _this.obtenirNombreInitial('zoom', 1),
      erreur: false,
      ouvert: _this.props.ouvert
    };
    return _this;
  }

  _createClass(MfaDocumentPdf, [{
    key: "obtenirNombreInitial",
    value: function obtenirNombreInitial(nomPropriete, valeurParDefaut) {
      var propriete = this.props[nomPropriete];

      if ((0, _utilitaires.estNombre)(propriete)) {
        return Number(propriete);
      }

      return valeurParDefaut;
    }
  }, {
    key: "surFermeture",
    value: function surFermeture() {
      var surFermeture = this.props.surFermeture;
      document.body.style.overflow = null;

      if (!(0, _utilitaires.estDefini)(surFermeture)) {
        return;
      }

      surFermeture();
    }
  }, {
    key: "obtenirSource",
    value: function obtenirSource() {
      var source = this.state.source;

      if (source === this.sourceEtatPrecedente && (0, _utilitaires.estDefini)(this.sourceDonneePrecedente)) {
        return this.sourceDonneePrecedente;
      }

      this.sourceEtatPrecedente = source;

      if (source instanceof File) {
        this.chargerFichier(source);
      } else if (typeof source === 'string') {
        return this.sourceDonneePrecedente = this.extraireSourceChaine();
      } else if (source instanceof Uint8Array) {
        return this.sourceDonneePrecedente = {
          data: source
        };
      } else if (source instanceof ArrayBuffer) {
        return this.sourceDonneePrecedente = {
          data: new Uint8Array(source)
        };
      }

      return null;
    }
  }, {
    key: "extraireSourceChaine",
    value: function extraireSourceChaine() {
      var source = this.state.source;

      if (source.match(/^http[s]?:\/\/|file:/)) {
        return source;
      } else if (source.match(/^[A-Za-z]:\\/)) {
        return "file://".concat(source);
      } else if (source.match(/^JVBER/)) {
        this.chargerChaine64("data:application/pdf;base64,".concat(source));
      } else {
        this.chargerChaine64(source);
      }

      return null;
    }
  }, {
    key: "chargerChaine64",
    value: function () {
      var _chargerChaine = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(chaine) {
        var resultat, rangee, tableau;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(chaine);

              case 2:
                resultat = _context.sent;
                _context.next = 5;
                return resultat.arrayBuffer();

              case 5:
                rangee = _context.sent;
                tableau = (0, _utilitaires.estDefini)(rangee) && rangee instanceof ArrayBuffer ? new Uint8Array(rangee) : null;
                this.setState({
                  source: tableau
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function chargerChaine64(_x) {
        return _chargerChaine.apply(this, arguments);
      }

      return chargerChaine64;
    }()
  }, {
    key: "chargerFichier",
    value: function () {
      var _chargerFichier = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fichier) {
        var rangee, tableau;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.lireFichierRangee(fichier);

              case 2:
                rangee = _context2.sent;
                tableau = (0, _utilitaires.estDefini)(rangee) && rangee instanceof ArrayBuffer ? new Uint8Array(rangee) : null;
                this.setState({
                  source: tableau
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function chargerFichier(_x2) {
        return _chargerFichier.apply(this, arguments);
      }

      return chargerFichier;
    }()
  }, {
    key: "lireFichierRangee",
    value: function () {
      var _lireFichierRangee = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fichier) {
        var lecteur;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                lecteur = new FileReader();
                return _context3.abrupt("return", new Promise(function (resoudre, rejeter) {
                  lecteur.readAsArrayBuffer(fichier);

                  lecteur.onload = function () {
                    return resoudre(lecteur.result);
                  };

                  lecteur.onerror = function (erreur) {
                    return rejeter(erreur);
                  };
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function lireFichierRangee(_x3) {
        return _lireFichierRangee.apply(this, arguments);
      }

      return lireFichierRangee;
    }()
  }, {
    key: "obtenirBase64",
    value: function obtenirBase64() {
      var sourceDonneePrecedente = this.sourceDonneePrecedente;

      if (!(0, _utilitaires.estDefini)(sourceDonneePrecedente) || !(sourceDonneePrecedente.data instanceof Uint8Array)) {
        return null;
      }

      var lecteur = new FileReader();
      var blob = new Blob([sourceDonneePrecedente.data.buffer]);
      return new Promise(function (resoudre, rejeter) {
        lecteur.onload = function () {
          return resoudre(lecteur.result.replace('octet-stream', 'pdf'));
        };

        lecteur.onerror = function () {
          return rejeter();
        };

        lecteur.readAsDataURL(blob);
      });
    }
  }, {
    key: "surDocumentChargerAvecSucces",
    value: function surDocumentChargerAvecSucces(_ref) {
      var numPages = _ref.numPages;
      this.surDocumentCharger(numPages, false);
    }
  }, {
    key: "surDocumentChargerAvecErreur",
    value: function surDocumentChargerAvecErreur() {
      this.surDocumentCharger(0, true);
    }
  }, {
    key: "surDocumentCharger",
    value: function surDocumentCharger(nombrePages, erreur) {
      var _this2 = this;

      this.setState({
        nombrePages: nombrePages,
        charge: true,
        erreur: erreur
      }, function () {
        return _this2.chargerObserveur();
      });
    }
  }, {
    key: "chargerObserveur",
    value: function chargerObserveur() {
      var _this3 = this;

      this.ajusterTexte();
      var observeur = this.observeur;

      if ((0, _utilitaires.estDefini)(observeur)) {
        observeur.disconnect();
      }

      observeur = new MutationObserver(function () {
        return _this3.ajusterElements();
      });
      observeur.observe(this.referenceVisionneur.element, {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true
      });
    }
  }, {
    key: "surTelechargement",
    value: function surTelechargement() {
      var sourceDonneePrecedente = this.sourceDonneePrecedente;
      var nomFichier = this.props.nomFichier;

      if (!(0, _utilitaires.estDefini)(sourceDonneePrecedente)) {
        return;
      }

      var lienBidon = document.createElement("a");
      lienBidon.style.display = "none";
      document.body.appendChild(lienBidon);
      var url;

      if (typeof sourceDonneePrecedente === 'string') {
        url = sourceDonneePrecedente;
      } else {
        var blob = new Blob([sourceDonneePrecedente.data.buffer]);
        url = window.URL.createObjectURL(blob);
      }

      lienBidon.href = url;
      lienBidon.download = (0, _utilitaires.estDefini)(nomFichier) ? nomFichier : 'document.pdf';
      lienBidon.click();
      window.URL.revokeObjectURL(url);
      lienBidon.parentElement.removeChild(lienBidon);
    }
  }, {
    key: "surConfirmation",
    value: function surConfirmation() {
      var surConfirmation = this.props.surConfirmation;

      if ((0, _utilitaires.estDefini)(surConfirmation)) {
        surConfirmation();
      }
    }
  }, {
    key: "surAffichage",
    value: function () {
      var _surAffichage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var chaineBase64, byteArray, file, fileURL;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.obtenirBase64();

              case 2:
                chaineBase64 = _context4.sent;

                if ((0, _utilitaires.estDefini)(chaineBase64)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                byteArray = this.sourceDonneePrecedente.data;
                file = new Blob([byteArray], {
                  type: 'application/pdf;base64'
                });
                fileURL = URL.createObjectURL(file);
                window.open(fileURL);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function surAffichage() {
        return _surAffichage.apply(this, arguments);
      }

      return surAffichage;
    }()
  }, {
    key: "surChangementZoom",
    value: function surChangementZoom(zoom) {
      var _this4 = this;

      this.setState({
        zoom: zoom
      }, function () {
        var referenceVisionneur = _this4.referenceVisionneur;

        if (!(0, _utilitaires.estDefini)(referenceVisionneur)) {
          return;
        }

        var element = referenceVisionneur.element;

        if (!(0, _utilitaires.estDefini)(element)) {
          return;
        }
      });
    }
  }, {
    key: "ajusterElements",
    value: function ajusterElements() {
      var estModal = this.props.estModal;
      this.ajusterTexte();

      if (estModal === true) {
        this.ajusterVisonneur();
      }
    }
  }, {
    key: "ajusterTexte",
    value: function ajusterTexte() {
      this.ajusterSelonCanvas('.react-pdf__Page__textContent');
    }
  }, {
    key: "ajusterVisonneur",
    value: function ajusterVisonneur() {
      var referenceVisionneur = this.referenceVisionneur;

      if (!(0, _utilitaires.estDefini)(referenceVisionneur)) {
        return;
      }

      var element = referenceVisionneur.element;

      if (!(0, _utilitaires.estDefini)(element)) {
        return;
      }

      var elementCanvas = element.querySelector('canvas');

      if (!(0, _utilitaires.estDefini)(elementCanvas)) {
        return;
      }

      var largeurVisionneur = (0, _utilitaires2.largeur)(elementCanvas);

      if (largeurVisionneur !== 0) {
        element.style.width = "".concat(largeurVisionneur, "px");
      }
    }
  }, {
    key: "ajusterBoutons",
    value: function ajusterBoutons() {
      this.ajusterSelonCanvas('.conteneur-boutons', 'mfa-documentpdf-visionneur-entete', function (canvas) {
        return (0, _utilitaires2.largeur)(canvas) + 10;
      });
    }
  }, {
    key: "ajusterSelonCanvas",
    value: function ajusterSelonCanvas(selecteurCible, selecteurParent, callbackAjout) {
      var referenceVisionneur = this.referenceVisionneur;

      if (!(0, _utilitaires.estDefini)(referenceVisionneur)) {
        return;
      }

      var element = referenceVisionneur.element;

      if (!(0, _utilitaires.estDefini)(element)) {
        return;
      }

      var elementCanvas = element.querySelector('canvas');
      var elementCible = element.querySelector(selecteurCible);

      if (!(0, _utilitaires.estDefini)(elementCible) || !(0, _utilitaires.estDefini)(elementCanvas)) {
        return;
      }

      var parent = (0, _utilitaires.estDefini)(selecteurParent) ? element.querySelector(selecteurParent) : null;
      var distance = (0, _utilitaires2.distanceHorizontale)(elementCanvas, parent) + ((0, _utilitaires.estDefini)(callbackAjout) ? callbackAjout(elementCanvas) : 0);
      elementCible.style.left = "".concat(distance, "px");
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this5 = this;

      var ouvert = this.props.ouvert;

      if (ouvert === true) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = null;
      }

      return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
        className: "mfa-documentpdf",
        appElement: document.body,
        isOpen: ouvert === true,
        contentElement: function contentElement(props, children) {
          return _this5.renderVisionneur(children);
        }
      }, this.renderDocument());
    }
  }, {
    key: "renderNormal",
    value: function renderNormal() {
      return this.renderVisionneur(this.renderDocument());
    }
  }, {
    key: "obtenirProprieteVisionneur",
    value: function obtenirProprieteVisionneur() {
      var _this6 = this;

      var proprietes = (0, _utilitaires.extraireProprietesObjet)(this.props, 'estModal', 'affichable', 'fermable', 'telechargable', 'confirmationMessage', 'etiquetteConfirmation', 'dateConfirmation', 'etiquetteBoutonConfirmation');
      ['surFermeture', 'surTelechargement', 'surAffichage', 'surConfirmation', 'surChangementZoom'].forEach(function (nomPropriete) {
        return proprietes[nomPropriete] = _this6[nomPropriete].bind(_this6);
      });
      var proprietesEtat = (0, _utilitaires.extraireProprietesObjet)(this.state, 'charge', 'nombrePages');
      var erreur = this.state.erreur;

      if (erreur === true) {
        proprietes.telechargable = false;
        proprietes.affichable = false;
      }

      Object.assign(proprietes, proprietesEtat);
      return proprietes;
    }
  }, {
    key: "renderVisionneur",
    value: function renderVisionneur(document) {
      var _this7 = this;

      var estModal = this.props.estModal;
      return /*#__PURE__*/_react.default.createElement(_MfaDocumentPdfVisionneur.MfaDocumentPdfVisionneur, _extends({}, this.obtenirProprieteVisionneur(), {
        renderPied: (0, _utilitaires.estDefini)(this.state.nombrePages) && this.state.nombrePages !== 0,
        ref: function ref(_ref2) {
          return (0, _utilitaires.enregistrerSiDefini)(_this7, 'referenceVisionneur', _ref2);
        },
        surChangementPage: function surChangementPage(noPage) {
          return _this7.setState({
            noPage: noPage
          });
        }
      }), document);
    }
  }, {
    key: "renderDocument",
    value: function renderDocument() {
      return /*#__PURE__*/_react.default.createElement(_reactPdf.Document, {
        onLoadSuccess: this.surDocumentChargerAvecSucces.bind(this),
        onLoadError: this.surDocumentChargerAvecErreur.bind(this),
        file: this.obtenirSource(),
        error: "Impossible de charger le pdf",
        noData: "Il n\\'y a pas de donn\xE9es",
        loading: "Chargment..."
      }, /*#__PURE__*/_react.default.createElement(_reactPdf.Page, {
        scale: this.state.zoom,
        loading: "Chargement...",
        pageNumber: this.state.noPage,
        renderTextLayer: this.props.selectionnable === true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var source = this.obtenirSource();

      if (!(0, _utilitaires.estDefini)(source)) {
        return null;
      }

      var estModal = this.props.estModal;

      if (estModal === true) {
        return this.renderModal();
      } else {
        return this.renderNormal();
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(procahineProps, etatPrecedent) {
      if (etatPrecedent.sourceOriginale !== procahineProps.source) {
        var source = (0, _utilitaires.estDefini)(procahineProps.source) ? procahineProps.source : null;
        return {
          source: source,
          sourceOriginale: source,
          noPage: 1
        };
      } else if (etatPrecedent.ouvert !== procahineProps.ouvert) {
        return {
          ouvert: procahineProps.ouvert
        };
      }

      return null;
    }
  }]);

  return MfaDocumentPdf;
}(_react.Component);

exports.MfaDocumentPdf = MfaDocumentPdf;